export default __webpack_public_path__ + "static/media/virtual-bg12.dfff1f7f.png";